// extracted by mini-css-extract-plugin
module.exports = {"link":"link__1ZA0S","wrap":"wrap__12-gl"};